import React from 'react'
import { Box } from 'theme-ui'

const Secondary = () => {
  return <Box sx={{fontSize: [5], color: 'secondary'}}>
    This is secondary too
  </Box>
}

export default Secondary
